module.exports = __webpack_public_path__ + "img/dinapsis-color.20564a82.svg";